import InfiniteScrollLoader from "~/infiniteScrollLoader";
import INote from "~/interfaces/noteInterface";
import Note from "~/models/formSubmission/correspondences/note";
import NoteProvider from "~/providers/noteProvider";
import {IObjectModelEntry} from "~/interfaces/objectModelInterfaces"

export default function () {
  const noteProvider = <NoteProvider>new NoteProvider();

  return {
    namespaced: true,
    state: {
      notesFullyLoaded: false,
      notesInfiniteLoader: <InfiniteScrollLoader>new InfiniteScrollLoader(function (requestData: {query: {entry_id: string, q?: string, offset?: number}}) {
        return new Promise((resolve, reject) => {
          noteProvider.fetch(requestData.query).then(result => {
            resolve({result, objects: (result as any).notes});
          });
        });
      }),
    },
    mutations: {
      addEntryNote(state, {json, entry}: { json: any, entry: IObjectModelEntry } = {json: {}, entry: null}) {
        if (!entry) throw new Error('entry must be provided')

        const note = new Note().loadFromJson(json);
        note.newNote = true;
        entry.notes.push(note);
        return note;
      },
      addEntryNotes(state, {notesJson, entry}: {notesJson: INote[], entry: IObjectModelEntry}) {
        if (!entry) throw new Error('entry must be provided')

        const newNotes = notesJson.map(json => new Note().loadFromJson(json));
        entry.notes.unshift(...newNotes);
      },
      setNotesFullyLoaded(state, newValue: boolean) {
        state.notesFullyLoaded = newValue;
      },
    },
    actions: {
      fetchEntryNotes({commit, state}, {entry, requestData}: {entry, requestData: {q: string, offset: number, referrer: object}}): Promise<{ success: boolean, notes: Note[], isFullyLoaded: boolean }> {
        if (!entry) throw new Error('entry must be provided')

        return new Promise((resolve, reject) => {
          state.notesInfiniteLoader.fetch({
            query: {
              entry_id: entry.id,
              ignoreForNormalization: ['offset'],
              ...requestData,
            },
          })
            .then(({result, objects, isFullyLoaded, isNewQuery}) => {
              commit('addEntryNotes', {notesJson: objects, entry});
              commit('setNotesFullyLoaded', isFullyLoaded);
              resolve({success: result.success, notes: entry.notes, isFullyLoaded});
            });
        });
      },
      fetchRemainingEntryNotes({commit, state}, {entry, requestData}: {entry, requestData: {q: string, referrer: object}}) {
        if (!entry) throw new Error('entry must be provided')

        const offset = entry.notes.length;
        return new Promise((resolve, reject) => {
          noteProvider.fetchRemaining({offset, entry_id: entry.id, form_submission_id: null, ...requestData})
            .then(results => {
              commit('addEntryNotes', {notesJson: results.notes, entry});
              commit('setNotesFullyLoaded', true);
              resolve({success: results.success, notes: entry.notes, isFullyLoaded: true});
            });
        });
      },
      addEntryNote({commit, state}, {noteJson, referrer, entry}) {
        if (!entry) throw new Error('entry must be provided')

        return new Promise((resolve, reject) => {
          noteProvider.add({note: noteJson, referrer}).then(result => {
            // No need to add new note to entry if not on detail view page. Don't add if note is for related entry.
            if (noteJson.detail_view_id && noteJson.entry_id === entry.id) {
              const note = commit('addEntryNote', {json: result.note, entry});
              resolve(note);
            }
          });
        });
      },
    }
  };
}
